import { ElementLocation, ElementLocationPath } from './typings/guide/LayerCommon';
import { PATH } from './ModelConstant';
import { ELEMENT_PATHS, ELEMENT_PATH_SEARCH_STRATEGY } from './enum/ModelEnum';

/**
 * @deprecated use NODE_PATH from yeself-common/enum/ModelEnum.ts
 */
export const NO_PATH = 'NO_PATH';

export const postProcessPaths = (
    location: ElementLocation,
    usedLocales: { code: string }[],
    locale: string
): ElementLocationPath[] =>
    location.paths.map((locationPath) => {
        switch (locationPath.id) {
            case ELEMENT_PATHS.XPATH:
                return {
                    ...locationPath,
                    path: usedLocales.reduce(
                        (acc, { code }) => ({
                            ...acc,
                            [code]: code === locale ? locationPath.path : PATH.NOT_RECORDED_YET,
                        }),
                        {}
                    ),
                    searchStrategy: ELEMENT_PATH_SEARCH_STRATEGY.EXACT_ROOT_MATCH,
                };
            case ELEMENT_PATHS.JS_PATH:
                return {
                    ...locationPath,
                    searchStrategy: ELEMENT_PATH_SEARCH_STRATEGY.JS_PATH_QUERY,
                };
            case ELEMENT_PATHS.JS_PATH_NON_RELATIVE:
                return {
                    ...locationPath,
                    searchStrategy: ELEMENT_PATH_SEARCH_STRATEGY.JS_PATH_QUERY,
                };
            default:
                return {
                    ...locationPath,
                    searchStrategy: ELEMENT_PATH_SEARCH_STRATEGY.EXACT_ROOT_MATCH,
                };
        }
    });
